import React from 'react';
import { Card, CardContent, Box, Typography, Avatar, useTheme, alpha } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatCard = ({ title, value, icon: Icon, change, changeType = 'increase', color = 'primary', subtitle }) => {
  const theme = useTheme();
  
  const isPositive = changeType === 'increase';
  const iconColor = color === 'primary' ? theme.palette.primary.main :
                    color === 'secondary' ? theme.palette.secondary.main :
                    color === 'success' ? theme.palette.success.main :
                    color === 'error' ? theme.palette.error.main :
                    color === 'warning' ? theme.palette.warning.main :
                    color === 'info' ? theme.palette.info.main : color;

  return (
    <Card 
      sx={{ 
        height: '100%',
        position: 'relative',
        overflow: 'visible',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.shadows[8],
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <Box sx={{ flex: 1 }}>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              gutterBottom
              sx={{ fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5 }}
            >
              {title}
            </Typography>
            <Typography variant="h4" component="div" sx={{ fontWeight: 700, my: 1 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
            {change !== undefined && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                {isPositive ? (
                  <TrendingUp sx={{ fontSize: 16, color: 'success.main', mr: 0.5 }} />
                ) : (
                  <TrendingDown sx={{ fontSize: 16, color: 'error.main', mr: 0.5 }} />
                )}
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: isPositive ? 'success.main' : 'error.main',
                    fontWeight: 600 
                  }}
                >
                  {change}% {isPositive ? 'increase' : 'decrease'}
                </Typography>
              </Box>
            )}
          </Box>
          <Avatar
            sx={{
              bgcolor: alpha(iconColor, 0.1),
              color: iconColor,
              width: 56,
              height: 56,
            }}
          >
            {Icon && <Icon sx={{ fontSize: 28 }} />}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;











